// extracted by mini-css-extract-plugin
export default {"overviewArrayValue":"U0DSaP"};